<template>
	<div
		v-if="visible"
		class="intro"
	>
		<div
			ref="container"
			class="lottie"
		/>
	</div>
</template>

<script setup lang="ts">
	import lottie from 'lottie-web';
	import { SplashScreen } from '@capacitor/splash-screen';
	import { onMounted, ref } from 'vue';
	import AnimationCarJson from '~/assets/image/Loading_car.json';
	import { useDictionariesStore } from '~/store/dictionaries.store';

	const visible = ref(true);
	const container = ref<HTMLDivElement | null>(null);
	const route = useRoute();
	const isAuthPage = computed(() => {
		return route.path.startsWith('/authorization');
	});
	const dictionariesStrore = useDictionariesStore();
	let loadingFallbackTimer: ReturnType<typeof setTimeout> | null = null;
	let domLoaded = false;
	let animInstance: any = null;
	const pickupStatuses = computed(() => dictionariesStrore.loading.pickupStatuses);

	onMounted(async () => {
		const animInstance = lottie.loadAnimation({
			container: container.value!,
			renderer: 'svg',
			loop: true,
			autoplay: false,
			animationData: AnimationCarJson
		});

		animInstance.addEventListener('DOMLoaded', async () => {
			domLoaded = true;

			// requestAnimationFrame(() => {
			// 	animInstance.play();
			// });

			await SplashScreen.hide();

			if (isAuthPage.value) {
				visible.value = false;
			} else {
				setTimeout(() => {
					animInstance.play();
				}, 100);
			}
		});

		watch(
			() => pickupStatuses.value,
			(loading) => {
				if (loading === false) {
					setTimeout(() => {
						visible.value = false;
					}, 1200);
				}
			},
			{ immediate: false }
		);

		loadingFallbackTimer = setTimeout(() => {
			visible.value = false;
		}, 10000);
	});

	onBeforeUnmount(() => {
		if (loadingFallbackTimer) {
			clearTimeout(loadingFallbackTimer);
		}
		if (animInstance) {
			animInstance.destroy();
		}
	});
</script>

<style scoped>
	.intro {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		min-height: 100vh;
		background: white;
		z-index: 9999;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.lottie {
		width: 200px;
		height: 200px;
		flex-shrink: 0;
	}
</style>
